import React from "react";
import { generalIcons } from "../../utils/constants";

function BridgeBanner() {
  return (
    <section className="relative pb-6 lg:pb-12">
      <div className="max-w-[950px] mx-auto text-center">
        <h1
          style={{
            fontSize: "clamp(2.625rem, 2.15rem + 2.375vw, 5rem)",
            lineHeight: "clamp(2rem, 1.6rem + 2vw, 4rem)",
          }}
          className="font-bold font-sans uppercase  gradient-text bg-left-bottom bg-textGd mb-3 lg:mb-5"
        >
          Bridge to Vanar Chain
        </h1>
        <div className="flex flex-col items-center gap-4 lg:gap-2  relative">
          <div className="flex items-center justify-center gap-2 px-3 lg:px-6 py-3 rounded-2xl border-[1.5px] border-white/10 text-left bg-black/10 backdrop-blur-[20px] w-fit relative relative z-0">
            <span className="w-7 h-7">{generalIcons.coin}</span>
            <h4 className="text-[16px]/4 lg:text-[18px]/5 tracking-tighter md:-tracking-[1.1px] font-semibold text-gunMetal mb-0">
              {" "}
              {/* <span className="font-semibold font-serif">Buy $VANRY</span> using popular
              cryptocurrencies like <span className="">ETH, BTC, or USDT</span>. */}
              <span className="font-semibold font-serif">Buy $VANRY</span> using popular cryptocurrencies like ETH, BTC, or USDT.
            </h4>
            
          </div>
          <div className="flex items-center justify-center gap-2 px-3 lg:px-6 py-3 rounded-2xl border-[1.5px] border-white/10 text-left bg-black/10 backdrop-blur-[20px] w-fit relative z-0">
            <span className="w-7 h-7">{generalIcons.swapVanry}</span>
            <h4 className="text-[16px]/4 lg:text-[18px]/5 tracking-tighter md:-tracking-[1.1px] font-semibold text-gunMetal mb-0">
              {" "}
              {/* <span className="font-semibold">Swap $VANRY</span> cross-chain
              between Ethereum and the Vanar blockchain effortlessly. */}
              <span className="font-semibold font-serif">Swap $VANRY</span> cross-chain between Ethereum and the Vanar blockchain
              effortlessly.
            </h4>
          </div>
          <span className="size-8 md:size-10 flex items-center justify-center absolute top-[50%] translate-y-[-50%] *:size-full duration-300 rounded-full bg-gradinetbg *:p-0.5 *:md:p-0 z-9">
              <span className="flex items-center justify-center !size-4">
                {generalIcons.refresh}
              </span>
            </span>
        </div>
        {/* <a href={redirections.BRIDGE}
            target="_blank"
            rel="noreferrer">
            <Button
              className="py-4 md:py-5 px-10 bg-dim !text-sm text-[#101010]"
            >
              Bridge Now
            </Button>
          </a> */}
      </div>
    </section>
  );
}

export default BridgeBanner;
